/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  EmailTemplateDetailsDto,
  EmailTemplateListItemDto,
  TemplatePlaceholderDto,
  TemplatePlaceholderFilterDto,
} from '@gh/builder-shared-data';
import { UploadItem } from '@gh/core-ui';

export type EmailTemplateList = EmailTemplateListItemDto;
export type EmailTemplateDetails = EmailTemplateDetailsDto & { images?: UploadItem[]; bodyText?: string };
export type EmailPlaceholder = TemplatePlaceholderDto;
export type EmailPlaceholderFilter = TemplatePlaceholderFilterDto;

export const PLACEHOLDER_CODE_SIGN = '$';
export const FOOTER_EMAIL_TEMPLATE_SUBJECT = 'Footer';
export const HEADER_EMAIL_TEMPLATE_SUBJECT = 'Header';
